import i18n from "../../../i18n";
import { Notification } from "../../../Utils/Notification";

export const clearState = (state, action, initial) => {
  return {
    ...state,
    [action.state]: initial[action.state]
  }
};



export const getOrgsOfAdmin = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, OrgsOfAdmin: updateValue };
};
export const getOrgsOfAdminSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data?.entity,
    error: null,
  };
  return { ...state, OrgsOfAdmin: updateValue };
};
export const getOrgsOfAdminFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  Notification.pushNotif(i18n.dir() === "rtl" ? action.error.response?.data?.messageFa : action.error.response?.data?.message, "error")
  return { ...state, OrgsOfAdmin: updateValue };
};



export const setAdmin = (state, action) => {
  const updateValue = {
    request: action.data,
    response: null,
    error: null,
  };
  return { ...state, setAdmin: updateValue };
};
export const setAdminSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res.data,
    error: null,
  };

  return { ...state, setAdmin: updateValue };
};
export const setAdminFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, setAdmin: updateValue };
};